import { render, staticRenderFns } from "./CommentListBody.vue?vue&type=template&id=878ac13c&"
import script from "./CommentListBody.vue?vue&type=script&lang=js&"
export * from "./CommentListBody.vue?vue&type=script&lang=js&"
import style0 from "./CommentListBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports